import { render, staticRenderFns } from "./YandexMap.vue?vue&type=template&id=48265d2b&lang=pug&"
import script from "./YandexMap.vue?vue&type=script&lang=js&"
export * from "./YandexMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports